import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=20afe164&scoped=true&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=20afe164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afe164",
  null
  
)

export default component.exports